import {
  defineMessages,
  MessageDescriptor
} from 'react-intl';

export enum LANGUAGE_KEY {
  ABOUT_MASTERY_ITEMONE = 'ABOUT_MASTERY_ITEMONE',
  ABOUT_MASTERY_ITEMTHREE = 'ABOUT_MASTERY_ITEMTHREE',
  ABOUT_MASTERY_ITEMTWO = 'ABOUT_MASTERY_ITEMTWO',
  ABOUT_MASTERY_RESET = 'ABOUT_MASTERY_RESET',
  ACTION = 'ACTION',
  ACTIONS = 'ACTIONS',
  ACTIONS_RESULTS_MESSAGE = 'ACTIONS_RESULTS_MESSAGE',
  ADD = 'ADD',
  ADDITIONAL_LESSONS_COMING_SOON = 'ADDITIONAL_LESSONS_COMING_SOON',
  ADD_A_FOLDER = 'ADD_A_FOLDER',
  ADD_A_RESOURCE = 'ADD_A_RESOURCE',
  ADD_DATE_RANGE_TO_EACH_UNIT = 'ADD_DATE_RANGE_TO_EACH_UNIT',
  ADD_MANAGE_EAB_BANK_AND_ASSESSMENT = 'ADD_MANAGE_EAB_BANK_AND_ASSESSMENT',
  ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT = 'ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT',
  ADD_MORE_RESOURCES = 'ADD_MORE_RESOURCES',
  ADD_RESOURCES = 'ADD_RESOURCES',
  ADD_SINGLE_RESOURCE = 'ADD_SINGLE_RESOURCE',
  ALL_ATTEMPTS_TITLE = 'ALL_ATTEMPTS_TITLE',
  ALL_ITEMS = 'ALL_ITEMS',
  ALL_RATIONALES = 'ALL_RATIONALES',
  ALL_VIEWS = 'ALL_VIEWS',
  ALREADY_UNASSIGNED_SKIPPED = 'ALREADY_UNASSIGNED_SKIPPED',
  APPLICATION = 'APPLICATION',
  APPLY_TO_ALL = 'APPLY_TO_ALL',
  AREA = 'AREA',
  ARE_YOU_SURE = 'ARE_YOU_SURE',
  ASSIGNMENT_CAN_NOT_BE_UNASSIGNED = 'ASSIGNMENT_CAN_NOT_BE_UNASSIGNED',
  ASSIGNMENT_CONTENT_ID_IS_EMPTY = 'ASSIGNMENT_CONTENT_ID_IS_EMPTY',
  ASSIGNMENT_PERFORMANCE = 'ASSIGNMENT_PERFORMANCE',
  ASSIGNMENT_REPORT_TITLE = 'ASSIGNMENT_REPORT_TITLE',
  ASSIGNMENT_STARTED_EDIT_RESTRICTIONS = 'ASSIGNMENT_STARTED_EDIT_RESTRICTIONS',
  ASSIGNMENT_SUBMISSIONS_TITLE = 'ASSIGNMENT_SUBMISSIONS_TITLE',
  ASSIGNMENT_TITLE_IS_EMPTY = 'ASSIGNMENT_TITLE_IS_EMPTY',
  ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING = 'ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING',
  ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING = 'ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING',
  ATTEMPT = 'ATTEMPT',
  ATTEMPT_LIMIT = 'ATTEMPT_LIMIT',
  AUTHESS_MODAL_MESSAGE = 'AUTHESS_MODAL_MESSAGE',
  AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT = 'AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT',
  AVERAGE_QUESTIONS_MESSAGE = 'AVERAGE_QUESTIONS_MESSAGE',
  AVERAGE_QUESTION_PERFORMANCE = 'AVERAGE_QUESTION_PERFORMANCE',
  AVERAGE_MASTERY_IN_TOPIC = 'AVERAGE_MASTERY_IN_TOPIC',
  AVERAGE_SCORE = 'AVERAGE_SCORE',
  BATCH_ACTIONS_BAR_DESELECT_ALL = 'BATCH_ACTIONS_BAR_DESELECT_ALL',
  BATCH_ACTIONS_BAR_EDIT_DATES = 'BATCH_ACTIONS_BAR_EDIT_DATES',
  BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW = 'BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW',
  BATCH_ACTIONS_BAR_MOVE_REORDER = 'BATCH_ACTIONS_BAR_MOVE_REORDER',
  BATCH_ACTIONS_BAR_REMOVE = 'BATCH_ACTIONS_BAR_REMOVE',
  BATCH_ACTIONS_BAR_SELECT_ALL = 'BATCH_ACTIONS_BAR_SELECT_ALL',
  BATCH_ACTIONS_BAR_UNASSIGN = 'BATCH_ACTIONS_BAR_UNASSIGN',
  BATCH_ACTION_BAR_EDIT_CLOSE = 'BATCH_ACTION_BAR_EDIT_CLOSE',
  BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED = 'BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED',
  BOOK_SECTION = 'BOOK_SECTION',
  BULK_ADD = 'BULK_ADD',
  BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL = 'BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL',
  BULK_EDIT_SETTINGS_PAGE_BY_DAYS = 'BULK_EDIT_SETTINGS_PAGE_BY_DAYS',
  BULK_EDIT_SETTINGS_PAGE_BY_HOURS = 'BULK_EDIT_SETTINGS_PAGE_BY_HOURS',
  BULK_EDIT_SETTINGS_PAGE_BY_MINUTES = 'BULK_EDIT_SETTINGS_PAGE_BY_MINUTES',
  BULK_EDIT_SETTINGS_PAGE_BY_WEEKS = 'BULK_EDIT_SETTINGS_PAGE_BY_WEEKS',
  BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN = 'BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN',
  BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_DUE_COL = 'BULK_EDIT_SETTINGS_PAGE_DUE_COL',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE',
  // eslint-disable-next-line max-len
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_WARNING = 'BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_WARNING',
  BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_GRADE_TYPE_UNCHANGED_MODAL = 'BULK_EDIT_SETTINGS_PAGE_GRADE_TYPE_UNCHANGED_MODAL',
  BULK_EDIT_SETTINGS_PAGE_HEADER = 'BULK_EDIT_SETTINGS_PAGE_HEADER',
  BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL = 'BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL',
  BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL = 'BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL',
  BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES = 'BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES',
  BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES = 'BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES',
  BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL = 'BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL',
  BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL = 'BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL',
  BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB = 'BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB',
  BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN = 'BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN',
  BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR = 'BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR',
  BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING = 'BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING',
  BULK_SELECT = 'BULK_SELECT',
  BUTTON_ADD = 'BUTTON_ADD',
  BUTTON_ADD_A_FOLDER = 'BUTTON_ADD_A_FOLDER',
  BUTTON_ADD_MORE_RESOURCES = 'BUTTON_ADD_MORE_RESOURCES',
  CANCEL = 'CANCEL',
  CANCEL_AND_RETURN_TO_PREVIOUS_PAGE = 'CANCEL_AND_RETURN_TO_PREVIOUS_PAGE',
  CANNOT_BE_UNASSIGNED = 'CANNOT_BE_UNASSIGNED',
  CASES_ITEMS_NEXT_GENERATION = 'CASES_ITEMS_NEXT_GENERATION',
  CASE_STUDY = 'CASE_STUDY',
  CATALOG = 'CATALOG',
  CATALOG_ADD_CONFIRM_MESSAGE = 'CATALOG_ADD_CONFIRM_MESSAGE',
  CATALOG_ITEM_STATUS = 'CATALOG_ITEM_STATUS',
  CATALOG_ITEM_STATUS_VIEW_LESS_BTN = 'CATALOG_ITEM_STATUS_VIEW_LESS_BTN',
  CATALOG_ITEM_STATUS_VIEW_MORE_BTN = 'CATALOG_ITEM_STATUS_VIEW_MORE_BTN',
  CHANGE_COURSE = 'CHANGE_COURSE',
  CHOOSE_A_FINITE_NUMBER_OF_QUESTIONS = 'CHOOSE_A_FINITE_NUMBER_OF_QUESTIONS',
  CHOOSE_SPECIFIC_QUESTIONS = 'CHOOSE_SPECIFIC_QUESTIONS',
  CLASS_AVERAGE_ON_ALL_SUBMISSIONS = 'CLASS_AVERAGE_ON_ALL_SUBMISSIONS',
  CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS = 'CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
  CLICK_HERE = 'CLICK_HERE',
  CLOSE = 'CLOSE',
  COLLAPSE_ALL = 'COLLAPSE_ALL',
  COLLAPSE_ALL_FOLDERS = 'COLLAPSE_ALL_FOLDERS',
  COMING_SOON = 'COMING_SOON',
  COMPLETED = 'COMPLETED',
  COMPLETED_DATE = 'COMPLETED_DATE',
  COMPLETED_STUDENTS = 'COMPLETED_STUDENTS',
  COMPLETE_STUDENTS_TITLE = 'COMPLETE_STUDENTS_TITLE',
  CONFIRM = 'CONFIRM',
  CONFIRM_ACTION_ON_HIDDEN_SYLLABUS = 'CONFIRM_ACTION_ON_HIDDEN_SYLLABUS',
  CONFIRM_SELECTED_ITEMS = 'CONFIRM_SELECTED_ITEMS',
  CONFIRM_UNASSIGN_MODAL = 'CONFIRM_UNASSIGN_MODAL',
  COPY_COURSE_HAS_CONTENT_MESSAGE = 'COPY_COURSE_HAS_CONTENT_MESSAGE',
  COPY_COURSE_NO_CONTENT_MESSAGE = 'COPY_COURSE_NO_CONTENT_MESSAGE',
  COPY_DEEP_COPY_SUCCESS_TOAST = 'COPY_DEEP_COPY_SUCCESS_TOAST',
  COPY_DEEP_LINK_INSTRUCTIONS = 'COPY_DEEP_LINK_INSTRUCTIONS',
  COPY_URL = 'COPY_URL',
  CORRECT_ANSWERS = 'CORRECT_ANSWERS',
  COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE = 'COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE',
  COURSE_BUILDER_WHICH_CONTENT_TYPES = 'COURSE_BUILDER_WHICH_CONTENT_TYPES',
  COURSE_COPY_START_DATE_TOOLTIP = 'COURSE_COPY_START_DATE_TOOLTIP',
  COURSE_COPY_UNMAPPED_ITEMS_TITLE = 'COURSE_COPY_UNMAPPED_ITEMS_TITLE',
  COURSE_COPY_WARN_MSG_PART_1A = 'COURSE_COPY_WARN_MSG_PART_1A',
  COURSE_COPY_WARN_MSG_PART_2A = 'COURSE_COPY_WARN_MSG_PART_2A',
  COURSE_COPY_WARN_MSG_PART_2B = 'COURSE_COPY_WARN_MSG_PART_2B',
  COURSE_END_DATE = 'COURSE_END_DATE',
  COURSE_LOCKED_NOTIFICATION = 'COURSE_LOCKED_NOTIFICATION',
  COURSE_NAME = 'COURSE_NAME',
  COURSE_OWNER_LOCKED_NOTIFICATION = 'COURSE_OWNER_LOCKED_NOTIFICATION',
  COURSE_START_DATE = 'COURSE_START_DATE',
  CREATE_YOUR_COURSE = 'CREATE_YOUR_COURSE',
  CUSTOM = 'CUSTOM',
  CUSTOM_BY_QUESTIONS = 'CUSTOM_BY_QUESTIONS',
  DATE_CREATED = 'DATE_CREATED',
  DEEP_LINK_CREATE_WARNING_TOAST_LINE_1 = 'DEEP_LINK_CREATE_WARNING_TOAST_LINE_1',
  DEEP_LINK_CREATE_WARNING_TOAST_LINE_2 = 'DEEP_LINK_CREATE_WARNING_TOAST_LINE_2',
  DEFAULT_TAB = 'DEFAULT_TAB',
  DISMISS = 'DISMISS',
  DISMISS_ALL = 'DISMISS_ALL',
  DRAG_DROP_TOGGLE = 'DRAG_DROP_TOGGLE',
  DUE = 'DUE',
  DUE_BY = 'DUE_BY',
  DUE_DATE = 'DUE_DATE',
  DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE = 'DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE',
  DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS = 'DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS',
  DUE_DATE_RESULTS_MESSAGE = 'DUE_DATE_RESULTS_MESSAGE',
  DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1 = 'DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1',
  DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2 = 'DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2',
  DUE_ON_DATE_AT_TIME = 'DUE_ON_DATE_AT_TIME',
  DURATION = 'DURATION',
  EAQ_BLANK_ASSIGNMENT = 'EAQ_BLANK_ASSIGNMENT',
  EDIT_SETTINGS_NO_ITEMS_SELECTED = 'EDIT_SETTINGS_NO_ITEMS_SELECTED',
  ELSEVIER_ADAPTIVE_QUIZZING = 'ELSEVIER_ADAPTIVE_QUIZZING',
  EMAIL = 'EMAIL',
  ENTER_A_NUMBER = 'ENTER_A_NUMBER',
  ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS = 'ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS',
  ENTRY_EXCEEDS_LENGTH_LIMIT = 'ENTRY_EXCEEDS_LENGTH_LIMIT',
  ESTIMATED_TIME = 'ESTIMATED_TIME',
  EXAM_MODE_RATIONALES_MSG = 'EXAM_MODE_RATIONALES_MSG',
  EXPAND_ALL = 'EXPAND_ALL',
  EXPAND_ALL_FOLDERS = 'EXPAND_ALL_FOLDERS',
  EXTERNAL_LINK_TOOLTIP = 'EXTERNAL_LINK_TOOLTIP',
  EXTERNAL_LINK_URL_NOTE = 'EXTERNAL_LINK_URL_NOTE',
  E_G_NAME = 'E_G_NAME',
  E_G_NURSING_CARE = 'E_G_NURSING_CARE',
  E_G_SHERPATH_FOR_FUNDAMENTALS = 'E_G_SHERPATH_FOR_FUNDAMENTALS',
  FAIL = 'FAIL',
  FETCH_LAST_NUM_RESULTS = 'FETCH_LAST_NUM_RESULTS',
  FETCH_NEXT_100_RESULTS = 'FETCH_NEXT_100_RESULTS',
  FILTERS_ARE_ON = 'FILTERS_ARE_ON',
  FILTER_BY = 'FILTER_BY',
  FILTER_BY_APPLICATION = 'FILTER_BY_APPLICATION',
  FILTER_BY_STATUS = 'FILTER_BY_STATUS',
  FILTER_CONTENT_BY = 'FILTER_CONTENT_BY',
  FIND_QUESTIONS_BY_KEYWORDS = 'FIND_QUESTIONS_BY_KEYWORDS',
  FIRST_FOLDER_TITLE = 'FIRST_FOLDER_TITLE',
  GOAL = 'GOAL',
  GOAL_HEADER = 'GOAL_HEADER',
  GRADE = 'GRADE',
  GRADE_POINTS = 'GRADE_POINTS',
  GRADE_TYPE = 'GRADE_TYPE',
  GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT = 'GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT',
  GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT = 'GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT',
  GRADING = 'GRADING',
  GRADING_TYPE = 'GRADING_TYPE',
  GROUP_ACTIVITY_TITLE = 'GROUP_ACTIVITY_TITLE',
  HESI_FILTER_TOOLTIP = 'HESI_FILTER_TOOLTIP',
  HESI_FOCUS_CHAPTERS = 'HESI_FOCUS_CHAPTERS',
  HESI_LOGO_ALT = 'HESI_LOGO_ALT',
  HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS = 'HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS',
  HOW_MANY_UNIT_DO_YOU_NEED = 'HOW_MANY_UNIT_DO_YOU_NEED',
  ICON_NO_PAST_ASSIGNMENTS = 'ICON_NO_PAST_ASSIGNMENTS',
  ICON_NO_UPCOMING_ASSIGNMENTS = 'ICON_NO_UPCOMING_ASSIGNMENTS',
  IMPORT_EXISTING_QUIZ = 'IMPORT_EXISTING_QUIZ',
  INCLUDES = 'INCLUDES',
  INCLUDES_QUESTIONS_IMPORTED_FROM = 'INCLUDES_QUESTIONS_IMPORTED_FROM',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_STUDENTS_TITLE = 'INCOMPLETE_STUDENTS_TITLE',
  INCORRECT_ANSWERS = 'INCORRECT_ANSWERS',
  INDICATES_REQUIRED_FIELD = 'INDICATES_REQUIRED_FIELD',
  INFORMATION_TOOLTIP = 'INFORMATION_TOOLTIP',
  INTERACTIVE_REVIEW_QUESTIONS_PREVIEW = 'INTERACTIVE_REVIEW_QUESTIONS_PREVIEW',
  INCOMPLETE_DESCRIPTION = 'INCOMPLETE_DESCRIPTION',
  INTERMEDIATE = 'INTERMEDIATE',
  INTERMEDIATE_DESCRIPTION = 'INTERMEDIATE_DESCRIPTION',
  INVALID_AVAILABILITY_DATE = 'INVALID_AVAILABILITY_DATE',
  INVALID_DUE_DATE = 'INVALID_DUE_DATE',
  INVALID_GRADE_POINTS = 'INVALID_GRADE_POINTS',
  INVALID_PAGE_RANGE_ERROR = 'INVALID_PAGE_RANGE_ERROR',
  INVALID_URL_FORMAT = 'INVALID_URL_FORMAT',
  INVALID_URL_PROTOCOL = 'INVALID_URL_PROTOCOL',
  // eslint-disable-next-line max-len
  IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE = 'IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED = 'IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED',
  LAST_DATE_WATCHED = 'LAST_DATE_WATCHED',
  LATE = 'LATE',
  LIMITED = 'LIMITED',
  LATEST_ATTEMPT_SCORE_TITLE = 'LATEST_ATTEMPT_SCORE_TITLE',
  LATEST_DATE_WATCHED = 'LATEST_DATE_WATCHED',
  LATEST_SUBMISSION_TIME = 'LATEST_SUBMISSION_TIME',
  LAUNCH_STUDENT_VIEW = 'LAUNCH_STUDENT_VIEW',
  LEARNING_DURATION = 'LEARNING_DURATION',
  LOCKED = 'LOCKED',
  MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST = 'MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST',
  MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED = 'MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED',
  MAKE_VISIBLE_NOW_SUCCESS_TOAST = 'MAKE_VISIBLE_NOW_SUCCESS_TOAST',
  MASTERY = 'MASTERY',
  MASTERY_RESET_CANCEL = 'MASTERY_RESET_CANCEL',
  MASTERY_RESET_EMAIL_ADDRESS = 'MASTERY_RESET_EMAIL_ADDRESS',
  MASTERY_RESET_FIRST_NAME = 'MASTERY_RESET_FIRST_NAME',
  MASTERY_RESET_LAST_NAME = 'MASTERY_RESET_LAST_NAME',
  MASTERY_RESET_MODAL_HEADING = 'MASTERY_RESET_MODAL_HEADING',
  MASTERY_RESET_PAGE = 'MASTERY_RESET_PAGE',
  MASTERY_RESET_TOAST_MESSAGE = 'MASTERY_RESET_TOAST_MESSAGE',
  MASTERY_LEVEL_GOAL = 'MASTERY_LEVEL_GOAL',
  MISSED_ACTIONS = 'MISSED_ACTIONS',
  MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE = 'MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE',
  MOVE_REORDER_NO_ITEMS_SELECTED = 'MOVE_REORDER_NO_ITEMS_SELECTED',
  MY_BOOKS = 'MY_BOOKS',
  MY_COURSES = 'MY_COURSES',
  NEW_CONTENT = 'NEW_CONTENT',
  NEW_LESSONS = 'NEW_LESSONS',
  NEW_LESSONS_ARE_AVAILABLE = 'NEW_LESSONS_ARE_AVAILABLE',
  NEW_LESSONS_AVAILABLE_NOW = 'NEW_LESSONS_AVAILABLE_NOW',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NOT_DUE = 'NOT_DUE',
  NOT_GRADED = 'NOT_GRADED',
  NOT_STARTED = 'NOT_STARTED',
  NOT_VISIBLE = 'NOT_VISIBLE',
  NOVICE = 'NOVICE',
  NOVICE_DESCRIPTION = 'NOVICE_DESCRIPTION',
  NO_ASSIGNMENTS = 'NO_ASSIGNMENTS',
  NO_ASSIGNMENTS_STU = 'NO_ASSIGNMENTS_STU',
  NO_DUE_DATE = 'NO_DUE_DATE',
  NO_ENROLL = 'NO_ENROLL',
  NO_ITEM_TO_DISPLAY = 'NO_ITEM_TO_DISPLAY',
  NO_QUESTION_RESULTS = 'NO_QUESTION_RESULTS',
  NO_SELECTION = 'NO_SELECTION',
  NO_STUDENTS_SELECTED = 'NO_STUDENTS_SELECTED',
  NO_SUBMISSIONS = 'NO_SUBMISSIONS',
  NO_SUBMISSIONS_BEFORE_DUE_DATE = 'NO_SUBMISSIONS_BEFORE_DUE_DATE',
  NUMBER_OF_ATTEMPTS = 'NUMBER_OF_ATTEMPTS',
  NUMBER_OF_ALLOWED_ATTEMPTS = 'NUMBER_OF_ALLOWED_ATTEMPTS',
  NUMBER_OF_ALLOWED_ATTEMPTS_ERROR = 'NUMBER_OF_ALLOWED_ATTEMPTS_ERROR',
  NUMBER_OF_QUESTIONS = 'NUMBER_OF_QUESTIONS',
  NUMBER_OF_SELECTED = 'NUMBER_OF_SELECTED',
  NUMBER_OF_STUDENTS = 'NUMBER_OF_STUDENTS',
  NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS = 'NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS',
  NUM_QUESTIONS_IMPORTED = 'NUM_QUESTIONS_IMPORTED',
  NUM_TOPICS_SELECTED = 'NUM_TOPICS_SELECTED',
  OKAY = 'OKAY',
  ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL = 'ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL',
  OPEN_COURSE_SETUP = 'OPEN_COURSE_SETUP',
  OPEN_EBOOK = 'OPEN_EBOOK',
  OR_A_FOLDER = 'OR_A_FOLDER',
  OSMOSIS_PILOT_SURVEY_PROMPT = 'OSMOSIS_PILOT_SURVEY_PROMPT',
  OVERVIEW = 'OVERVIEW',
  PAGE_TITLE = 'PAGE_TITLE',
  PASS = 'PASS',
  PASS_FAIL = 'PASS_FAIL',
  PAST_ASSIGNMENTS = 'PAST_ASSIGNMENTS',
  PAST_DUE = 'PAST_DUE',
  PAST_DUE_ASSIGNMENTS = 'PAST_DUE_ASSIGNMENTS',
  PERCENT_OF_CLASS_PERFORMED_CORRECTLY = 'PERCENT_OF_CLASS_PERFORMED_CORRECTLY',
  PLEASE_NOTE_THAT_UNASSIGNING = 'PLEASE_NOTE_THAT_UNASSIGNING',
  PLEASE_SELECT_AN_OPTION = 'PLEASE_SELECT_AN_OPTION',
  PLEASE_SELECT_AT_LEAST_1_TOPIC = 'PLEASE_SELECT_AT_LEAST_1_TOPIC',
  PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE = 'PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE',
  PLEASE_TRY_ANOTHER_KEYWORD = 'PLEASE_TRY_ANOTHER_KEYWORD',
  POINTS = 'POINTS',
  PREVIEW = 'PREVIEW',
  PRE_NOVICE = 'PRE_NOVICE',
  PRE_SIMULATION_QUIZ_EDITOR = 'PRE_SIMULATION_QUIZ_EDITOR',
  PRE_SIMULATION_QUIZ_PREVIEW = 'PRE_SIMULATION_QUIZ_PREVIEW',
  PRODUCT = 'PRODUCT',
  PROFICIENT = 'PROFICIENT',
  PROFICIENT_DESCRIPTION = 'PROFICIENT_DESCRIPTION',
  PURCHASE_BINDER_READY_VERSION = 'PURCHASE_BINDER_READY_VERSION',
  QUESTION = 'QUESTION',
  QUESTIONS = 'QUESTIONS',
  QUESTIONS_ADDED_COVER = 'QUESTIONS_ADDED_COVER',
  QUESTIONS_ANSWERED = 'QUESTIONS_ANSWERED',
  QUESTION_CHOICES_OR_CORRECT_RESPONSES_ARE_MISSING = 'QUESTION_CHOICES_OR_CORRECT_RESPONSES_ARE_MISSING',
  QUESTION_DATA_IS_MISSING = 'QUESTION_DATA_IS_MISSING',
  QUESTION_PREVIEW = 'QUESTION_PREVIEW',
  QUESTION_PREVIEW_MODAL_TITLE = 'QUESTION_PREVIEW_MODAL_TITLE',
  QUESTION_PREVIEW_MODAL_TYPE = 'QUESTION_PREVIEW_MODAL_TYPE',
  QUESTION_SET = 'QUESTION_SET',
  QUICK_VIEW = 'QUICK_VIEW',
  QUIZ_OPTIONS = 'QUIZ_OPTIONS',
  RATIONALE = 'RATIONALE',
  READING_SELECTION = 'READING_SELECTION',
  REMOVE = 'REMOVE',
  REMOVE_NO_ITEMS_SELECTED = 'REMOVE_NO_ITEMS_SELECTED',
  REMOVE_QUESTIONS_SELECTED = 'REMOVE_QUESTIONS_SELECTED',
  REMOVE_QUESTIONS_SELECTED_MSG = 'REMOVE_QUESTIONS_SELECTED_MSG',
  REPORT_CONTENT_ERROR = 'REPORT_CONTENT_ERROR',
  RESET = 'RESET',
  RESET_MASTERY = 'RESET_MASTERY',
  RESET_MASTERY_LEVEL = 'RESET_MASTERY_LEVEL',
  RESOURCE_LIBRARY = 'RESOURCE_LIBRARY',
  RESOURCE_TYPE = 'RESOURCE_TYPE',
  RESULTS_FILTERED = 'RESULTS_FILTERED',
  REVIEW_NUM_QUESTIONS_SELECTED = 'REVIEW_NUM_QUESTIONS_SELECTED',
  REVIEW_NUM_QUESTION_SELECTED = 'REVIEW_NUM_QUESTION_SELECTED',
  SAVE_AND_COMPLETE = 'SAVE_AND_COMPLETE',
  SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS = 'SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS',
  SCORE = 'SCORE',
  SCORED = 'SCORED',
  SCORES = 'SCORES',
  SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN = 'SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN',
  SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE = 'SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE',
  SEARCH_COURSE_SECTION = 'SEARCH_COURSE_SECTION',
  SEARCH_FOR_A_STUDENT = 'SEARCH_FOR_A_STUDENT',
  SEARCH_RESOURCES = 'SEARCH_RESOURCES',
  SECTIONS = 'SECTIONS',
  SEE_LESS_TOPICS = 'SEE_LESS_TOPICS',
  SEE_MORE_TOPICS = 'SEE_MORE_TOPICS',
  SELECT_ALL = 'SELECT_ALL',
  SELECT_AN_OPTION = 'SELECT_AN_OPTION',
  SELECT_A_COURSE_TO_COPY = 'SELECT_A_COURSE_TO_COPY',
  SELECT_A_CUSTOM_BY_QUESTIONS_QUIZ = 'SELECT_A_CUSTOM_BY_QUESTIONS_QUIZ',
  SELECT_A_QUESTION_SET = 'SELECT_A_QUESTION_SET',
  SELECT_A_TOPIC_ORGANIZATION = 'SELECT_A_TOPIC_ORGANIZATION',
  SELECT_EXISTING_COURSE_REQUIRED_ERROR = 'SELECT_EXISTING_COURSE_REQUIRED_ERROR',
  SELECT_MASTERY_LEVEL_GOAL = 'SELECT_MASTERY_LEVEL_GOAL',
  SELECT_MASTERY_GOAL_RADIO = 'SELECT_MASTERY_GOAL_RADIO',
  SELECT_ONE_TOPIC = 'SELECT_ONE_TOPIC',
  SELECT_QUESTIONS = 'SELECT_QUESTIONS',
  SET_ASSESSMENT_GOAL_FOR_ASSIGNMENT = 'SET_ASSESSMENT_GOAL_FOR_ASSIGNMENT',
  SET_AS_DEAFULT_TAB = 'SET_AS_DEAFULT_TAB',
  SET_OF_NGN_ITEMS_ALIGNED_TO_CLINICAL_CONTENT = 'SET_OF_NGN_ITEMS_ALIGNED_TO_CLINICAL_CONTENT',
  SHOWING_NUM_OF_NUM_QUESTIONS = 'SHOWING_NUM_OF_NUM_QUESTIONS',
  SIMULATION = 'SIMULATION',
  SIMULATION_IS_LOADING = 'SIMULATION_IS_LOADING',
  SIM_ACTIONS_TOOLTIP = 'SIM_ACTIONS_TOOLTIP',
  SKILL = 'SKILL',
  SKILL_ATTEMPT_RESULT_CORRECT_TAB = 'SKILL_ATTEMPT_RESULT_CORRECT_TAB',
  SKILL_ATTEMPT_RESULT_HEADER = 'SKILL_ATTEMPT_RESULT_HEADER',
  SKILL_ATTEMPT_RESULT_INCORRECT_TAB = 'SKILL_ATTEMPT_RESULT_INCORRECT_TAB',
  START_A_QUIZ = 'START_A_QUIZ',
  START_DATE = 'START_DATE',
  START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER = 'START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER',
  STATUS = 'STATUS',
  STUDENT = 'STUDENT',
  STUDENTS_WATCHED_THIS_VIDEO = 'STUDENTS_WATCHED_THIS_VIDEO',
  STUDENT_ENGAGEMENT = 'STUDENT_ENGAGEMENT',
  STUDENT_LAUNCH_WARNING = 'STUDENT_LAUNCH_WARNING',
  STUDENT_NAME = 'STUDENT_NAME',
  STUDENT_SCORES_TITLE = 'STUDENT_SCORES_TITLE',
  STUDY_MODE_RATIONALES_MSG1 = 'STUDY_MODE_RATIONALES_MSG1',
  STUDY_MODE_RATIONALES_MSG2 = 'STUDY_MODE_RATIONALES_MSG2',
  SUBMISSION_ATTEMPTS_TITLE = 'SUBMISSION_ATTEMPTS_TITLE',
  SUBMISSION_TIME = 'SUBMISSION_TIME',
  SWITCHING_TO_ANOTHER_QUESTION_MSG = 'SWITCHING_TO_ANOTHER_QUESTION_MSG',
  SYSTEM_REQUIREMENT_NOTE = 'SYSTEM_REQUIREMENT_NOTE',
  THE_FOLDER_IS_EMPTY = 'THE_FOLDER_IS_EMPTY',
  THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR = 'THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR',
  THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASSIGNMENTS_WILL_NOT_BE_PRESERVED = 'THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASSIGNMENTS_WILL_NOT_BE_PRESERVED',
  THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS = 'THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS',
  THIS_LESSON_HAS_NOT_RELEASE_YET = 'THIS_LESSON_HAS_NOT_RELEASE_YET',
  THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE = 'THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE',
  TIME_SPENT = 'TIME_SPENT',
  TOAST_SUCCESS_ADD_SYLLABUS = 'TOAST_SUCCESS_ADD_SYLLABUS',
  TOAST_SUCCESS_MOVE_SYLLABUS = 'TOAST_SUCCESS_MOVE_SYLLABUS',
  TOAST_SUCCESS_UPDATE_ASSIGNMENTS = 'TOAST_SUCCESS_UPDATE_ASSIGNMENTS',
  TOAST_SUCCESS_UPDATE_SYLLABUS = 'TOAST_SUCCESS_UPDATE_SYLLABUS',
  TOGGLE_TRANSCRIPT = 'TOGGLE_TRANSCRIPT',
  TOPICS = 'TOPICS',
  TOPIC_ORGANIZATION = 'TOPIC_ORGANIZATION',
  TO_BE_UNASSIGNED = 'TO_BE_UNASSIGNED',
  TRANSCRIPT = 'TRANSCRIPT',
  UNABLE_TO_DROP_EXCEED_LIMIT = 'UNABLE_TO_DROP_EXCEED_LIMIT',
  UNABLE_TO_DROP_INTO_ITS_CHILDREN = 'UNABLE_TO_DROP_INTO_ITS_CHILDREN',
  UNABLE_TO_DROP_ITSELF = 'UNABLE_TO_DROP_ITSELF',
  UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED = 'UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED',
  UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED = 'UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED',
  UNASSIGN_NO_ITEMS_SELECTED = 'UNASSIGN_NO_ITEMS_SELECTED',
  UNLIMITED = 'UNLIMITED',
  UNLIMITED_PERSONALIZED_QUESTIONS_WILL_BE_PRESENTED = 'UNLIMITED_PERSONALIZED_QUESTIONS_WILL_BE_PRESENTED',
  UPCOMING_ASSIGNMENTS = 'UPCOMING_ASSIGNMENTS',
  UPCOMING_LESSONS = 'UPCOMING_LESSONS',
  UPCOMING_LESSONS_MODAL_MESSAGE = 'UPCOMING_LESSONS_MODAL_MESSAGE',
  UPCOMING_TAB_MESSAGE = 'UPCOMING_TAB_MESSAGE',
  VALUE_REQUIRED = 'VALUE_REQUIRED',
  VIDEO_COMPLETED_RESULTS_MESSAGE = 'VIDEO_COMPLETED_RESULTS_MESSAGE',
  VIDEO_COMPLETION = 'VIDEO_COMPLETION',
  VIDEO_COMPLETION_BASED_ON_LATEST_VIEW = 'VIDEO_COMPLETION_BASED_ON_LATEST_VIEW',
  VIEW = 'VIEW',
  VIEW_ALL_ATTEMPTS = 'VIEW_ALL_ATTEMPTS',
  VIEW_SUBMISSION = 'VIEW_SUBMISSION',
  VIEW_ATTEMPT_RESULTS = 'VIEW_ATTEMPT_RESULTS',
  VIEW_DETAILS = 'VIEW_DETAILS',
  VIEW_FULLSCREEN = 'VIEW_FULLSCREEN',
  VIEW_NEW_LESSONS = 'VIEW_NEW_LESSONS',
  VIEW_SYSTEM_REQUIREMENTS = 'VIEW_SYSTEM_REQUIREMENTS',
  VIEW_UPCOMING_LESSONS = 'VIEW_UPCOMING_LESSONS',
  VISIBLE_ON_DATE_AT_TIME = 'VISIBLE_ON_DATE_AT_TIME',
  VISIBLE_UPON_RELEASE = 'VISIBLE_UPON_RELEASE',
  WANT_TO_PROCEED = 'WANT_TO_PROCEED',
  WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED = 'WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED',
  WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED = 'WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED',
  WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER = 'WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER',
  WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM = 'WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM',
  WARNING_MESSAGE_FOR_UPCOMING_LESSON = 'WARNING_MESSAGE_FOR_UPCOMING_LESSON',
  WELCOME_TO_YOUR_COURSE = 'WELCOME_TO_YOUR_COURSE',
  WELCOME_USER = 'WELCOME_USER',
  WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE = 'WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE',
  WHAT_WOULD_YOU_LIKE_TO_COVER = 'WHAT_WOULD_YOU_LIKE_TO_COVER',
  WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE = 'WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE',
  YOUR_COURSE_PLAN_IS_EMPTY = 'YOUR_COURSE_PLAN_IS_EMPTY',
  YOUR_FILTERED_RESULT_IS_EMPTY = 'YOUR_FILTERED_RESULT_IS_EMPTY',
  YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED = 'YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED',
  ZERO_TOTAL_TOPICS_SELECTED = 'ZERO_TOTAL_TOPICS_SELECTED',
  NAME = 'NAME',
  MASTERY_RESET_MODAL_HEADER = 'MASTERY_RESET_MODAL_HEADER',
  MASTERY_RESET_MODAL_WARNING = 'MASTERY_RESET_MODAL_WARNING',
  CONFIRM_MASTERY_RESET_MODAL = 'CONFIRM_MASTERY_RESET_MODAL'
}

const messages = Object.keys(LANGUAGE_KEY)
  .reduce((acc, cur) => ({
    ...acc,
    [cur]: {
      id: cur,
      defaultMessage: cur
    }
  }), {}) as Record<LANGUAGE_KEY, MessageDescriptor>;

export const Translations = defineMessages<LANGUAGE_KEY>(messages);

// Define list of static messages that can be translated without passing any value in
export const StaticMessagesKeys: LANGUAGE_KEY[] = [
  LANGUAGE_KEY.ABOUT_MASTERY_ITEMONE,
  LANGUAGE_KEY.ABOUT_MASTERY_ITEMTHREE,
  LANGUAGE_KEY.ABOUT_MASTERY_ITEMTWO,
  LANGUAGE_KEY.ABOUT_MASTERY_RESET,
  LANGUAGE_KEY.ACTION,
  LANGUAGE_KEY.ACTIONS,
  LANGUAGE_KEY.ACTIONS_RESULTS_MESSAGE,
  LANGUAGE_KEY.ADD,
  LANGUAGE_KEY.ADDITIONAL_LESSONS_COMING_SOON,
  LANGUAGE_KEY.ADD_A_FOLDER,
  LANGUAGE_KEY.ADD_A_RESOURCE,
  LANGUAGE_KEY.ADD_DATE_RANGE_TO_EACH_UNIT,
  LANGUAGE_KEY.ADD_MANAGE_EAB_BANK_AND_ASSESSMENT,
  LANGUAGE_KEY.ADD_MANAGE_EAB_TEST_BANK_AND_ASSESSMENT,
  LANGUAGE_KEY.ADD_MORE_RESOURCES,
  LANGUAGE_KEY.ADD_RESOURCES,
  LANGUAGE_KEY.ADD_SINGLE_RESOURCE,
  LANGUAGE_KEY.ALL_ATTEMPTS_TITLE,
  LANGUAGE_KEY.ALL_ITEMS,
  LANGUAGE_KEY.ALL_RATIONALES,
  LANGUAGE_KEY.ALL_VIEWS,
  LANGUAGE_KEY.ALREADY_UNASSIGNED_SKIPPED,
  LANGUAGE_KEY.APPLICATION,
  LANGUAGE_KEY.APPLY_TO_ALL,
  LANGUAGE_KEY.AREA,
  LANGUAGE_KEY.ARE_YOU_SURE,
  LANGUAGE_KEY.ASSIGNMENT_CAN_NOT_BE_UNASSIGNED,
  LANGUAGE_KEY.ASSIGNMENT_CONTENT_ID_IS_EMPTY,
  LANGUAGE_KEY.ASSIGNMENT_PERFORMANCE,
  LANGUAGE_KEY.ASSIGNMENT_REPORT_TITLE,
  LANGUAGE_KEY.ASSIGNMENT_STARTED_EDIT_RESTRICTIONS,
  LANGUAGE_KEY.ASSIGNMENT_SUBMISSIONS_TITLE,
  LANGUAGE_KEY.ASSIGNMENT_TITLE_IS_EMPTY,
  LANGUAGE_KEY.ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_PASS_FAIL_GRADING,
  LANGUAGE_KEY.ASSIGNMENT_TYPE_DOES_NOT_SUPPORT_SCORE_GRADING,
  LANGUAGE_KEY.ATTEMPT,
  LANGUAGE_KEY.ATTEMPT_LIMIT,
  LANGUAGE_KEY.AUTHESS_MODAL_MESSAGE,
  LANGUAGE_KEY.AVERAGE_ACTION_SCORE_ON_BEST_ATTEMPT,
  LANGUAGE_KEY.AVERAGE_QUESTIONS_MESSAGE,
  LANGUAGE_KEY.AVERAGE_QUESTION_PERFORMANCE,
  LANGUAGE_KEY.AVERAGE_MASTERY_IN_TOPIC,
  LANGUAGE_KEY.AVERAGE_SCORE,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_DESELECT_ALL,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_EDIT_DATES,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_MAKE_VISIBLE_NOW,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_MOVE_REORDER,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_REMOVE,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_SELECT_ALL,
  LANGUAGE_KEY.BATCH_ACTIONS_BAR_UNASSIGN,
  LANGUAGE_KEY.BATCH_ACTION_BAR_EDIT_CLOSE,
  LANGUAGE_KEY.BATCH_ACTION_BAR_EDIT_DATES_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.BOOK_SECTION,
  LANGUAGE_KEY.BULK_ADD,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_AVAILABLE_FROM_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_DAYS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_HOURS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_MINUTES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_BY_WEEKS,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_CANCEL_BTN,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_CHANGE_ALL_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_DUE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_EDIT_GRADING_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_AVAILABLE_DATE_NO_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_DUE_DATE_NO_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_CHANGE_ALL_GRADING_STARTED_ASSIGNMENT_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_HEADING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_AVAILABLE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_DUE_DATE,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_TAB_NO_GRADING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EDIT_SETTINGS_UNPUBLISHED_LESSON_SKIPPED_WARNING,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_EXTEND_ALL_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_HEADER,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_INCLUDE_AVAILABLE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_INCLUDE_DUE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_PUSH_AVAILABILITY_DATES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_PUSH_DUE_DATES,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_RESOURCE_NAME_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_RESOURCE_TYPE_COL,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_SHIFT_DATES_TAB,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_PAGE_SUBMIT_BTN,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_SUBMIT_TOAST_ERROR,
  LANGUAGE_KEY.BULK_EDIT_SETTINGS_TEACHING_RESOURCE_WARNING,
  LANGUAGE_KEY.BULK_SELECT,
  LANGUAGE_KEY.BUTTON_ADD,
  LANGUAGE_KEY.BUTTON_ADD_A_FOLDER,
  LANGUAGE_KEY.BUTTON_ADD_MORE_RESOURCES,
  LANGUAGE_KEY.CANCEL,
  LANGUAGE_KEY.CANCEL_AND_RETURN_TO_PREVIOUS_PAGE,
  LANGUAGE_KEY.CANNOT_BE_UNASSIGNED,
  LANGUAGE_KEY.CASES_ITEMS_NEXT_GENERATION,
  LANGUAGE_KEY.CASE_STUDY,
  LANGUAGE_KEY.CATALOG,
  LANGUAGE_KEY.CATALOG_ITEM_STATUS_VIEW_LESS_BTN,
  LANGUAGE_KEY.CHANGE_COURSE,
  LANGUAGE_KEY.CHOOSE_A_FINITE_NUMBER_OF_QUESTIONS,
  LANGUAGE_KEY.CHOOSE_SPECIFIC_QUESTIONS,
  LANGUAGE_KEY.CLASS_AVERAGE_ON_ALL_SUBMISSIONS,
  LANGUAGE_KEY.CLASS_AVERAGE_ON_VIDEO_COMPLETION_FOR_ALL_VIEWS,
  LANGUAGE_KEY.CLEAR_FILTERS,
  LANGUAGE_KEY.CLEAR_SEARCH,
  LANGUAGE_KEY.CLICK_HERE,
  LANGUAGE_KEY.CLOSE,
  LANGUAGE_KEY.COLLAPSE_ALL,
  LANGUAGE_KEY.COLLAPSE_ALL_FOLDERS,
  LANGUAGE_KEY.COMING_SOON,
  LANGUAGE_KEY.COMPLETED,
  LANGUAGE_KEY.COMPLETED_DATE,
  LANGUAGE_KEY.COMPLETED_STUDENTS,
  LANGUAGE_KEY.COMPLETE_STUDENTS_TITLE,
  LANGUAGE_KEY.CONFIRM,
  LANGUAGE_KEY.CONFIRM_ACTION_ON_HIDDEN_SYLLABUS,
  LANGUAGE_KEY.CONFIRM_UNASSIGN_MODAL,
  LANGUAGE_KEY.COPY_COURSE_HAS_CONTENT_MESSAGE,
  LANGUAGE_KEY.COPY_COURSE_NO_CONTENT_MESSAGE,
  LANGUAGE_KEY.COPY_DEEP_COPY_SUCCESS_TOAST,
  LANGUAGE_KEY.COPY_DEEP_LINK_INSTRUCTIONS,
  LANGUAGE_KEY.COPY_URL,
  LANGUAGE_KEY.CORRECT_ANSWERS,
  LANGUAGE_KEY.COURSE_BUILDER_PREVIEW_DEFAULT_MESSAGE,
  LANGUAGE_KEY.COURSE_BUILDER_WHICH_CONTENT_TYPES,
  LANGUAGE_KEY.COURSE_COPY_START_DATE_TOOLTIP,
  LANGUAGE_KEY.COURSE_COPY_UNMAPPED_ITEMS_TITLE,
  LANGUAGE_KEY.COURSE_COPY_WARN_MSG_PART_2A,
  LANGUAGE_KEY.COURSE_END_DATE,
  LANGUAGE_KEY.COURSE_LOCKED_NOTIFICATION,
  LANGUAGE_KEY.COURSE_NAME,
  LANGUAGE_KEY.COURSE_OWNER_LOCKED_NOTIFICATION,
  LANGUAGE_KEY.COURSE_START_DATE,
  LANGUAGE_KEY.CREATE_YOUR_COURSE,
  LANGUAGE_KEY.CUSTOM,
  LANGUAGE_KEY.CUSTOM_BY_QUESTIONS,
  LANGUAGE_KEY.DATE_CREATED,
  LANGUAGE_KEY.DEEP_LINK_CREATE_WARNING_TOAST_LINE_1,
  LANGUAGE_KEY.DEEP_LINK_CREATE_WARNING_TOAST_LINE_2,
  LANGUAGE_KEY.DEFAULT_TAB,
  LANGUAGE_KEY.DISMISS,
  LANGUAGE_KEY.DISMISS_ALL,
  LANGUAGE_KEY.DRAG_DROP_TOGGLE,
  LANGUAGE_KEY.DUE,
  LANGUAGE_KEY.DUE_BY,
  LANGUAGE_KEY.DUE_DATE,
  LANGUAGE_KEY.DUE_DATE_BEFORE_AVAILABLE_DATE_ERROR_MESSAGE,
  LANGUAGE_KEY.DUE_DATE_IS_REQUIRED_FOR_ALL_EAQ_ASSIGNMENTS,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE1,
  LANGUAGE_KEY.DUE_DATE_RESULTS_MESSAGE_SIMULATION_LINE2,
  LANGUAGE_KEY.DUE_ON_DATE_AT_TIME,
  LANGUAGE_KEY.DURATION,
  LANGUAGE_KEY.EAQ_BLANK_ASSIGNMENT,
  LANGUAGE_KEY.EDIT_SETTINGS_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.ELSEVIER_ADAPTIVE_QUIZZING,
  LANGUAGE_KEY.EMAIL,
  LANGUAGE_KEY.ENTER_A_NUMBER,
  LANGUAGE_KEY.ENTER_PAGE_NUMBER_AND_OR_PAGE_RANGES_SEPARATED_BY_COMMAS,
  LANGUAGE_KEY.ENTRY_EXCEEDS_LENGTH_LIMIT,
  LANGUAGE_KEY.ESTIMATED_TIME,
  LANGUAGE_KEY.EXAM_MODE_RATIONALES_MSG,
  LANGUAGE_KEY.EXPAND_ALL,
  LANGUAGE_KEY.EXPAND_ALL_FOLDERS,
  LANGUAGE_KEY.EXTERNAL_LINK_TOOLTIP,
  LANGUAGE_KEY.EXTERNAL_LINK_URL_NOTE,
  LANGUAGE_KEY.E_G_NAME,
  LANGUAGE_KEY.E_G_NURSING_CARE,
  LANGUAGE_KEY.E_G_SHERPATH_FOR_FUNDAMENTALS,
  LANGUAGE_KEY.FAIL,
  LANGUAGE_KEY.FETCH_LAST_NUM_RESULTS,
  LANGUAGE_KEY.FETCH_NEXT_100_RESULTS,
  LANGUAGE_KEY.FILTERS_ARE_ON,
  LANGUAGE_KEY.FILTER_BY,
  LANGUAGE_KEY.FILTER_BY_APPLICATION,
  LANGUAGE_KEY.FILTER_BY_STATUS,
  LANGUAGE_KEY.FILTER_CONTENT_BY,
  LANGUAGE_KEY.FIND_QUESTIONS_BY_KEYWORDS,
  LANGUAGE_KEY.FIRST_FOLDER_TITLE,
  LANGUAGE_KEY.GOAL,
  LANGUAGE_KEY.GOAL_HEADER,
  LANGUAGE_KEY.GRADE,
  LANGUAGE_KEY.GRADE_POINTS,
  LANGUAGE_KEY.GRADE_TYPE,
  LANGUAGE_KEY.GRADE_TYPE_AND_GRADE_POINTS_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT,
  LANGUAGE_KEY.GRADE_TYPE_CANNOT_BE_CHANGED_ON_STARTED_ASSIGNMENT,
  LANGUAGE_KEY.GRADING,
  LANGUAGE_KEY.GRADING_TYPE,
  LANGUAGE_KEY.GROUP_ACTIVITY_TITLE,
  LANGUAGE_KEY.HESI_FILTER_TOOLTIP,
  LANGUAGE_KEY.HESI_FOCUS_CHAPTERS,
  LANGUAGE_KEY.HESI_LOGO_ALT,
  LANGUAGE_KEY.HOW_DO_YOU_ORGANIZE_YOUR_SYLLABUS,
  LANGUAGE_KEY.HOW_MANY_UNIT_DO_YOU_NEED,
  LANGUAGE_KEY.ICON_NO_PAST_ASSIGNMENTS,
  LANGUAGE_KEY.ICON_NO_UPCOMING_ASSIGNMENTS,
  LANGUAGE_KEY.IMPORT_EXISTING_QUIZ,
  LANGUAGE_KEY.INCLUDES_QUESTIONS_IMPORTED_FROM,
  LANGUAGE_KEY.INCOMPLETE,
  LANGUAGE_KEY.INCOMPLETE_STUDENTS_TITLE,
  LANGUAGE_KEY.INCORRECT_ANSWERS,
  LANGUAGE_KEY.INDICATES_REQUIRED_FIELD,
  LANGUAGE_KEY.INFORMATION_TOOLTIP,
  LANGUAGE_KEY.INTERACTIVE_REVIEW_QUESTIONS_PREVIEW,
  LANGUAGE_KEY.INCOMPLETE_DESCRIPTION,
  LANGUAGE_KEY.INTERMEDIATE,
  LANGUAGE_KEY.INTERMEDIATE_DESCRIPTION,
  LANGUAGE_KEY.INVALID_AVAILABILITY_DATE,
  LANGUAGE_KEY.INVALID_DUE_DATE,
  LANGUAGE_KEY.INVALID_GRADE_POINTS,
  LANGUAGE_KEY.INVALID_PAGE_RANGE_ERROR,
  LANGUAGE_KEY.INVALID_URL_FORMAT,
  LANGUAGE_KEY.INVALID_URL_PROTOCOL,
  LANGUAGE_KEY.IN_ORDER_TO_GET_STARTED_PLEASE_SELECT_HOW_YOU_WOULD_LIKE_TO_ORGANIZE_YOUR_COURSE_RESOURCE,
  LANGUAGE_KEY.IN_PROGRESS,
  LANGUAGE_KEY.IN_PROGRESS_OR_COMPLETED_GRADED_SKIPPED,
  LANGUAGE_KEY.LAST_DATE_WATCHED,
  LANGUAGE_KEY.LATE,
  LANGUAGE_KEY.LIMITED,
  LANGUAGE_KEY.LATEST_ATTEMPT_SCORE_TITLE,
  LANGUAGE_KEY.LATEST_DATE_WATCHED,
  LANGUAGE_KEY.LATEST_SUBMISSION_TIME,
  LANGUAGE_KEY.LAUNCH_STUDENT_VIEW,
  LANGUAGE_KEY.LEARNING_DURATION,
  LANGUAGE_KEY.LOCKED,
  LANGUAGE_KEY.MAKE_VISIBLE_NOW_ALREADY_AVAILABLE_WARNING_TOAST,
  LANGUAGE_KEY.MAKE_VISIBLE_NOW_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.MASTERY,
  LANGUAGE_KEY.MASTERY_RESET_CANCEL,
  LANGUAGE_KEY.MASTERY_RESET_EMAIL_ADDRESS,
  LANGUAGE_KEY.MASTERY_RESET_FIRST_NAME,
  LANGUAGE_KEY.MASTERY_RESET_LAST_NAME,
  LANGUAGE_KEY.MASTERY_RESET_MODAL_HEADING,
  LANGUAGE_KEY.MASTERY_RESET_PAGE,
  LANGUAGE_KEY.MASTERY_RESET_TOAST_MESSAGE,
  LANGUAGE_KEY.MASTERY_LEVEL_GOAL,
  LANGUAGE_KEY.MISSED_ACTIONS,
  LANGUAGE_KEY.MOVE_REORDER_ALL_ITEM_CANNOT_BE_SELECTED_TO_BE_MOVED_AT_ONCE,
  LANGUAGE_KEY.MOVE_REORDER_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.MY_BOOKS,
  LANGUAGE_KEY.MY_COURSES,
  LANGUAGE_KEY.NAME,
  LANGUAGE_KEY.NEW_CONTENT,
  LANGUAGE_KEY.NEW_LESSONS,
  LANGUAGE_KEY.NEW_LESSONS_ARE_AVAILABLE,
  LANGUAGE_KEY.NEW_LESSONS_AVAILABLE_NOW,
  LANGUAGE_KEY.NOT_AVAILABLE,
  LANGUAGE_KEY.NOT_DUE,
  LANGUAGE_KEY.NOT_GRADED,
  LANGUAGE_KEY.NOT_STARTED,
  LANGUAGE_KEY.NOT_VISIBLE,
  LANGUAGE_KEY.NOVICE,
  LANGUAGE_KEY.NOVICE_DESCRIPTION,
  LANGUAGE_KEY.NO_ASSIGNMENTS,
  LANGUAGE_KEY.NO_ASSIGNMENTS_STU,
  LANGUAGE_KEY.NO_DUE_DATE,
  LANGUAGE_KEY.NO_ENROLL,
  LANGUAGE_KEY.NO_ITEM_TO_DISPLAY,
  LANGUAGE_KEY.NO_QUESTION_RESULTS,
  LANGUAGE_KEY.NO_SELECTION,
  LANGUAGE_KEY.NO_STUDENTS_SELECTED,
  LANGUAGE_KEY.NO_SUBMISSIONS,
  LANGUAGE_KEY.NO_SUBMISSIONS_BEFORE_DUE_DATE,
  LANGUAGE_KEY.NUMBER_OF_ATTEMPTS,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS,
  LANGUAGE_KEY.NUMBER_OF_ALLOWED_ATTEMPTS_ERROR,
  LANGUAGE_KEY.NUMBER_OF_QUESTIONS,
  LANGUAGE_KEY.NUMBER_OF_SELECTED,
  LANGUAGE_KEY.NUMBER_OF_STUDENTS,
  LANGUAGE_KEY.NUMBER_OF_STUDENTS_WITH_ASSIGNMENTS,
  LANGUAGE_KEY.NUM_QUESTIONS_IMPORTED,
  LANGUAGE_KEY.NUM_TOPICS_SELECTED,
  LANGUAGE_KEY.OKAY,
  LANGUAGE_KEY.ONLY_FOLDERS_CAN_BE_DRAGGED_TO_THE_ROOT_LEVEL,
  LANGUAGE_KEY.OPEN_COURSE_SETUP,
  LANGUAGE_KEY.OPEN_EBOOK,
  LANGUAGE_KEY.OSMOSIS_PILOT_SURVEY_PROMPT,
  LANGUAGE_KEY.OVERVIEW,
  LANGUAGE_KEY.PAGE_TITLE,
  LANGUAGE_KEY.PASS,
  LANGUAGE_KEY.PASS_FAIL,
  LANGUAGE_KEY.PAST_ASSIGNMENTS,
  LANGUAGE_KEY.PAST_DUE,
  LANGUAGE_KEY.PAST_DUE_ASSIGNMENTS,
  LANGUAGE_KEY.PERCENT_OF_CLASS_PERFORMED_CORRECTLY,
  LANGUAGE_KEY.PLEASE_NOTE_THAT_UNASSIGNING,
  LANGUAGE_KEY.PLEASE_SELECT_AN_OPTION,
  LANGUAGE_KEY.PLEASE_SELECT_AT_LEAST_1_TOPIC,
  LANGUAGE_KEY.PLEASE_SELECT_AT_LEAST_ONE_CHAPTER_AND_PAGE,
  LANGUAGE_KEY.PLEASE_TRY_ANOTHER_KEYWORD,
  LANGUAGE_KEY.POINTS,
  LANGUAGE_KEY.PREVIEW,
  LANGUAGE_KEY.PRE_SIMULATION_QUIZ_EDITOR,
  LANGUAGE_KEY.PRE_SIMULATION_QUIZ_PREVIEW,
  LANGUAGE_KEY.PRODUCT,
  LANGUAGE_KEY.PROFICIENT,
  LANGUAGE_KEY.PROFICIENT_DESCRIPTION,
  LANGUAGE_KEY.PURCHASE_BINDER_READY_VERSION,
  LANGUAGE_KEY.QUESTION,
  LANGUAGE_KEY.QUESTIONS,
  LANGUAGE_KEY.QUESTIONS_ADDED_COVER,
  LANGUAGE_KEY.QUESTIONS_ANSWERED,
  LANGUAGE_KEY.QUESTION_CHOICES_OR_CORRECT_RESPONSES_ARE_MISSING,
  LANGUAGE_KEY.QUESTION_DATA_IS_MISSING,
  LANGUAGE_KEY.QUESTION_PREVIEW,
  LANGUAGE_KEY.QUESTION_PREVIEW_MODAL_TITLE,
  LANGUAGE_KEY.QUESTION_PREVIEW_MODAL_TYPE,
  LANGUAGE_KEY.QUESTION_SET,
  LANGUAGE_KEY.QUICK_VIEW,
  LANGUAGE_KEY.QUIZ_OPTIONS,
  LANGUAGE_KEY.RATIONALE,
  LANGUAGE_KEY.READING_SELECTION,
  LANGUAGE_KEY.REMOVE,
  LANGUAGE_KEY.REMOVE_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.REMOVE_QUESTIONS_SELECTED,
  LANGUAGE_KEY.REMOVE_QUESTIONS_SELECTED_MSG,
  LANGUAGE_KEY.REPORT_CONTENT_ERROR,
  LANGUAGE_KEY.RESET,
  LANGUAGE_KEY.RESET_MASTERY,
  LANGUAGE_KEY.RESET_MASTERY_LEVEL,
  LANGUAGE_KEY.RESOURCE_LIBRARY,
  LANGUAGE_KEY.RESOURCE_TYPE,
  LANGUAGE_KEY.RESULTS_FILTERED,
  LANGUAGE_KEY.REVIEW_NUM_QUESTIONS_SELECTED,
  LANGUAGE_KEY.REVIEW_NUM_QUESTION_SELECTED,
  LANGUAGE_KEY.SAVE_AND_COMPLETE,
  LANGUAGE_KEY.SAVE_AND_CONTINUE_TO_ADVANCED_SETTINGS,
  LANGUAGE_KEY.SCORE,
  LANGUAGE_KEY.SCORED,
  LANGUAGE_KEY.SCORES,
  LANGUAGE_KEY.SEARCH_BY_COURSE_NAME_PRODUCT_OR_ISBN,
  LANGUAGE_KEY.SEARCH_BY_KEYWORD_CHAPTER_OR_RESOURCE_TYPE,
  LANGUAGE_KEY.SEARCH_COURSE_SECTION,
  LANGUAGE_KEY.SEARCH_FOR_A_STUDENT,
  LANGUAGE_KEY.SEARCH_RESOURCES,
  LANGUAGE_KEY.SECTIONS,
  LANGUAGE_KEY.SEE_LESS_TOPICS,
  LANGUAGE_KEY.SEE_MORE_TOPICS,
  LANGUAGE_KEY.SELECT_ALL,
  LANGUAGE_KEY.SELECT_AN_OPTION,
  LANGUAGE_KEY.SELECT_A_COURSE_TO_COPY,
  LANGUAGE_KEY.SELECT_A_CUSTOM_BY_QUESTIONS_QUIZ,
  LANGUAGE_KEY.SELECT_A_QUESTION_SET,
  LANGUAGE_KEY.SELECT_A_TOPIC_ORGANIZATION,
  LANGUAGE_KEY.SELECT_EXISTING_COURSE_REQUIRED_ERROR,
  LANGUAGE_KEY.SELECT_MASTERY_LEVEL_GOAL,
  LANGUAGE_KEY.SELECT_MASTERY_GOAL_RADIO,
  LANGUAGE_KEY.SELECT_ONE_TOPIC,
  LANGUAGE_KEY.SELECT_QUESTIONS,
  LANGUAGE_KEY.SET_ASSESSMENT_GOAL_FOR_ASSIGNMENT,
  LANGUAGE_KEY.SET_AS_DEAFULT_TAB,
  LANGUAGE_KEY.SET_OF_NGN_ITEMS_ALIGNED_TO_CLINICAL_CONTENT,
  LANGUAGE_KEY.SHOWING_NUM_OF_NUM_QUESTIONS,
  LANGUAGE_KEY.SIMULATION,
  LANGUAGE_KEY.SIMULATION_IS_LOADING,
  LANGUAGE_KEY.SIM_ACTIONS_TOOLTIP,
  LANGUAGE_KEY.SKILL,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_CORRECT_TAB,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_HEADER,
  LANGUAGE_KEY.SKILL_ATTEMPT_RESULT_INCORRECT_TAB,
  LANGUAGE_KEY.START_A_QUIZ,
  LANGUAGE_KEY.START_DATE,
  LANGUAGE_KEY.START_YOUR_COURSE_BUILDING_BY_PROVIDING_A_NAME_FOR_YOUR_FIRST_FOLDER,
  LANGUAGE_KEY.STATUS,
  LANGUAGE_KEY.STUDENT,
  LANGUAGE_KEY.STUDENTS_WATCHED_THIS_VIDEO,
  LANGUAGE_KEY.STUDENT_ENGAGEMENT,
  LANGUAGE_KEY.STUDENT_LAUNCH_WARNING,
  LANGUAGE_KEY.STUDENT_NAME,
  LANGUAGE_KEY.STUDENT_SCORES_TITLE,
  LANGUAGE_KEY.STUDY_MODE_RATIONALES_MSG1,
  LANGUAGE_KEY.STUDY_MODE_RATIONALES_MSG2,
  LANGUAGE_KEY.SUBMISSION_ATTEMPTS_TITLE,
  LANGUAGE_KEY.SUBMISSION_TIME,
  LANGUAGE_KEY.SWITCHING_TO_ANOTHER_QUESTION_MSG,
  LANGUAGE_KEY.SYSTEM_REQUIREMENT_NOTE,
  LANGUAGE_KEY.THE_FOLDER_IS_EMPTY,
  LANGUAGE_KEY.THE_PAGE_NUMBERS_OUT_OF_SCOPE_ERROR,
  LANGUAGE_KEY.THE_PREVIOUS_CHANGES_YOU_MADE_ON_COURSE_PLAN_AND_THE_ASSIGNMENTS_WILL_NOT_BE_PRESERVED,
  LANGUAGE_KEY.THIS_COURSE_INCLUDES_THE_FOLLOWING_PRODUCTS,
  LANGUAGE_KEY.THIS_LESSON_HAS_NOT_RELEASE_YET,
  LANGUAGE_KEY.THIS_TYPICALLY_MATCHES_YOUR_SYLLABUS_STRUCTURE,
  LANGUAGE_KEY.TIME_SPENT,
  LANGUAGE_KEY.TOAST_SUCCESS_ADD_SYLLABUS,
  LANGUAGE_KEY.TOAST_SUCCESS_MOVE_SYLLABUS,
  LANGUAGE_KEY.TOAST_SUCCESS_UPDATE_ASSIGNMENTS,
  LANGUAGE_KEY.TOAST_SUCCESS_UPDATE_SYLLABUS,
  LANGUAGE_KEY.TOGGLE_TRANSCRIPT,
  LANGUAGE_KEY.TOPICS,
  LANGUAGE_KEY.TOPIC_ORGANIZATION,
  LANGUAGE_KEY.TO_BE_UNASSIGNED,
  LANGUAGE_KEY.TRANSCRIPT,
  LANGUAGE_KEY.UNABLE_TO_DROP_EXCEED_LIMIT,
  LANGUAGE_KEY.UNABLE_TO_DROP_INTO_ITS_CHILDREN,
  LANGUAGE_KEY.UNABLE_TO_DROP_ITSELF,
  LANGUAGE_KEY.UNABLE_TO_UNASSIGN_BECAUSE_ALREADY_UNASSIGNED,
  LANGUAGE_KEY.UNABLE_TO_UNASSIGN_BECAUSE_GRADED_STARTED,
  LANGUAGE_KEY.UNASSIGN_NO_ITEMS_SELECTED,
  LANGUAGE_KEY.UNLIMITED,
  LANGUAGE_KEY.UNLIMITED_PERSONALIZED_QUESTIONS_WILL_BE_PRESENTED,
  LANGUAGE_KEY.UPCOMING_ASSIGNMENTS,
  LANGUAGE_KEY.UPCOMING_LESSONS,
  LANGUAGE_KEY.UPCOMING_LESSONS_MODAL_MESSAGE,
  LANGUAGE_KEY.UPCOMING_TAB_MESSAGE,
  LANGUAGE_KEY.VALUE_REQUIRED,
  LANGUAGE_KEY.VIDEO_COMPLETED_RESULTS_MESSAGE,
  LANGUAGE_KEY.VIDEO_COMPLETION,
  LANGUAGE_KEY.VIDEO_COMPLETION_BASED_ON_LATEST_VIEW,
  LANGUAGE_KEY.VIEW,
  LANGUAGE_KEY.VIEW_ALL_ATTEMPTS,
  LANGUAGE_KEY.VIEW_SUBMISSION,
  LANGUAGE_KEY.VIEW_ATTEMPT_RESULTS,
  LANGUAGE_KEY.VIEW_DETAILS,
  LANGUAGE_KEY.VIEW_FULLSCREEN,
  LANGUAGE_KEY.VIEW_NEW_LESSONS,
  LANGUAGE_KEY.VIEW_SYSTEM_REQUIREMENTS,
  LANGUAGE_KEY.VIEW_UPCOMING_LESSONS,
  LANGUAGE_KEY.VISIBLE_ON_DATE_AT_TIME,
  LANGUAGE_KEY.VISIBLE_UPON_RELEASE,
  LANGUAGE_KEY.WANT_TO_PROCEED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_REMOVE_WHEN_FILTERED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNABLE_TO_REMOVE_WHEN_ASSIGNMENT_STARTED,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNASSIGN_WHEN_FILTER,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UNASSIGN_WHEN_THERE_IS_A_SKIPPED_ITEM,
  LANGUAGE_KEY.WARNING_MESSAGE_FOR_UPCOMING_LESSON,
  LANGUAGE_KEY.WELCOME_TO_YOUR_COURSE,
  LANGUAGE_KEY.WELCOME_USER,
  LANGUAGE_KEY.WE_NEED_TO_KNOW_A_LITTLE_MORE_ABOUT_HOW_TO_STRUCTURE_YOUR_COURSE,
  LANGUAGE_KEY.WHAT_WOULD_YOU_LIKE_TO_COVER,
  LANGUAGE_KEY.WOULD_YOU_LIKE_US_TO_AUTOMATICALLY_ADD_CONTENT_TO_YOUR_COURSE,
  LANGUAGE_KEY.YOUR_COURSE_PLAN_IS_EMPTY,
  LANGUAGE_KEY.YOUR_FILTERED_RESULT_IS_EMPTY,
  LANGUAGE_KEY.YOU_CAN_ADD_REMOVE_MOVE_CONTENT_AFTER_YOUR_COURSE_IS_CREATED,
  LANGUAGE_KEY.ZERO_TOTAL_TOPICS_SELECTED,
  LANGUAGE_KEY.MASTERY_RESET_MODAL_HEADER,
  LANGUAGE_KEY.MASTERY_RESET_MODAL_WARNING,
  LANGUAGE_KEY.CONFIRM_MASTERY_RESET_MODAL
];
